import { useEffect, useRef } from 'react';

import { useMode } from '@apps/web/lib/mode_store';

export function useOnModeChange(handler: () => void) {
    const mode = useMode();
    const prevRef = useRef(mode);
    const handlerRef = useRef(handler);
    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    useEffect(() => {
        if (prevRef.current !== mode) {
            handlerRef.current();
            prevRef.current = mode;
        }
    }, [mode]);
}
